import "./Policy.css";
import React from "react";
import { useParams, Link } from "react-router-dom";
import Privacy from "./bits/Privacy";
import Refund from "./bits/Refund";
import Service from "./bits/Service";

const policyComponents = {
    privacy: Privacy,
    refund: Refund,
    service: Service,
};

const policyLabels = {
    privacy: "Privacy Policy",
    refund: "Refund Policy",
    service: "Terms of Service",
};

export default function Policy() {
    const { policyName } = useParams();

    if (!policyName) {
        return (
            <div>
                <h2>Available Policies</h2>
                <ul>
                    {Object.entries(policyLabels).map(([key, label]) => (
                        <li key={key}>
                            <Link to={`/policy/${key}`}>{label}</Link>
                        </li>
                    ))}
                </ul>
            </div>
        );
    }

    const PolicyComponent = policyComponents[policyName?.toLowerCase()];

    if (!PolicyComponent) {
        return <div>Policy not found.</div>;
    }

    return <PolicyComponent />;
}
